module.exports = new __parcel__URL__("smiter.f05b7a65.png").toString();